<template>
  <div>
    <h1>Estatus Reembolso</h1>
  </div>
</template>

<script>
export default {
  name: 'RefundStatusMain',
}
</script>

<style lang="scss" scoped></style>
